module.exports = __webpack_public_path__ + "env.8db9a8ba.mp3";